import { css } from '@emotion/css';

import { useStyles } from '@/hooks/useStyles';
import { MailPreferenceItem } from '@/pages/account/preferences/MailPreferenceItem';
import { Queries } from '@/queries/Queries';

export const MailPreferenceBody = () => {
  const styles = useStyles(makeStyles);
  const mailPrefRequest = Queries.mailPreference.useMailPreference({});

  const mailData = mailPrefRequest.isSuccess ? mailPrefRequest.data : [];

  return (
    <div className={styles.container}>
      {mailData.map(mail => (
        <MailPreferenceItem mail={mail} key={mail.id} />
      ))}
    </div>
  );
};
const makeStyles = () => ({
  container: css`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  `,
});
